module.exports = __webpack_public_path__ + "img/14.13409fc7.jpg";